module.exports = __webpack_public_path__ + "static/media/103c6863.jpg";